export const HEADER_SITE_MODE = 'Coop-Site-Mode';
